/* Landing v2 (18-10-2026) · Kit Brújula / Kompass-Kit / Zestaw Kompas
   Total en vivo con bumps, botón → routes.cart_url/<variante>:1,<bump>:1?attributes[<consentimiento>]=<valor fecha>,
   casilla de consentimiento obligatoria con error visible, barra fija, visor de páginas y apariciones suaves.
   Los textos y el nombre del atributo vienen de data-* de la sección (uno por idioma). */
(function () {
  var r = document.querySelector('.kv[data-kv]');
  if (!r) return;
  window.kvListo = true;
  var $ = function (q) { return r.querySelector(q); };
  var $$ = function (q) { return Array.prototype.slice.call(r.querySelectorAll(q)); };
  var moneda = r.dataset.moneda || 'EUR', locale = r.dataset.locale || 'es-ES';

  function fmt(c) {
    var v = c / 100, d = (c % 100) ? 2 : 0;
    if (moneda === 'EUR') return v.toLocaleString(locale, { minimumFractionDigits: d, maximumFractionDigits: 2 }) + ' €';
    if (moneda === 'PLN') return v.toLocaleString('pl-PL', { minimumFractionDigits: d, maximumFractionDigits: 2 }) + ' zł';
    try { return v.toLocaleString(locale, { style: 'currency', currency: moneda, minimumFractionDigits: d }); }
    catch (e) { return v.toFixed(2) + ' ' + moneda; }
  }

  /* Compra */
  var cb = $('[data-kv-consent]'), caja = $('[data-kv-caja]'), msg = $('[data-kv-msg]'), btn = $('[data-kv-buy]');
  var extras = $$('[data-kv-extra]');
  function total() {
    var c = parseInt(btn.dataset.precio, 10) || 0;
    extras.forEach(function (x) { if (x.checked) c += parseInt(x.dataset.precio, 10) || 0; });
    $$('[data-kv-total]').forEach(function (t) { t.textContent = fmt(c); });
  }
  function enlace() {
    if (!cb.checked) { btn.setAttribute('href', '#' + btn.dataset.ancla); return; }
    var items = [btn.dataset.variante + ':1'];
    extras.forEach(function (x) { if (x.checked) items.push(x.dataset.variante + ':1'); });
    btn.href = btn.dataset.carrito + '/' + items.join(',') + '?attributes%5B' + encodeURIComponent(btn.dataset.atributo) + '%5D=' +
      encodeURIComponent(btn.dataset.valor + ' ' + new Date().toISOString());
  }
  if (btn && cb) {
    btn.addEventListener('click', function (e) {
      if (!cb.checked) {
        e.preventDefault(); msg.hidden = false; caja.classList.add('error'); cb.setAttribute('aria-invalid', 'true');
        caja.scrollIntoView({ block: 'center', behavior: 'smooth' }); cb.focus({ preventScroll: true });
      }
    });
    cb.addEventListener('change', function () {
      if (cb.checked) { msg.hidden = true; caja.classList.remove('error'); cb.removeAttribute('aria-invalid'); }
      enlace();
    });
    extras.forEach(function (x) { x.addEventListener('change', function () { total(); enlace(); }); });
    total(); enlace();
  }

  /* Barra fija: se esconde mientras se ve el botón del hero o la caja de compra */
  var fija = $('[data-kv-fija]'), compra = $('[data-kv-compra]'), heroCta = $('[data-kv-herocta]');
  if (fija && compra && heroCta && 'IntersectionObserver' in window) {
    var vis = [true, false];
    fija.classList.add('oculta');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { vis[e.target === compra ? 1 : 0] = e.isIntersecting; });
      fija.classList.toggle('oculta', vis[0] || vis[1]);
    }, { threshold: 0 });
    io.observe(heroCta); io.observe(compra);
  }

  /* Visor de páginas */
  var lb = $('[data-kv-lb]'), img = $('[data-kv-lbimg]'), pie = $('[data-kv-lbpie]'), bs = $$('[data-lb]'), i = 0;
  function ver(n) {
    i = (n + bs.length) % bs.length;
    var s = bs[i].querySelector('img');
    img.src = bs[i].dataset.grande || s.currentSrc || s.src; img.alt = s.alt; pie.textContent = (i + 1) + ' / ' + bs.length;
  }
  if (lb && bs.length) {
    bs.forEach(function (b, n) { b.addEventListener('click', function () { ver(n); if (lb.showModal) lb.showModal(); }); });
    $('[data-kv-ant]').onclick = function () { ver(i - 1); };
    $('[data-kv-sig]').onclick = function () { ver(i + 1); };
    $('[data-kv-cerrar]').onclick = function () { lb.close(); };
    lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
    lb.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') ver(i + 1); if (e.key === 'ArrowLeft') ver(i - 1); });
  }

  /* Apariciones (nunca en el hero) */
  var rv = $$('.rv');
  var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (quieto || !('IntersectionObserver' in window)) { rv.forEach(function (el) { el.classList.add('in'); }); return; }
  rv.forEach(function (el) {
    var hermanos = el.parentNode ? Array.prototype.filter.call(el.parentNode.children, function (h) { return h.classList.contains('rv'); }) : [];
    var idx = hermanos.indexOf(el);
    if (idx > 0) el.style.setProperty('--rv-retraso', Math.min(idx, 6) * 80 + 'ms');
  });
  var io2 = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io2.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  rv.forEach(function (el) { io2.observe(el); });
})();
